export default "/person.png"